import React, { useRef, useEffect } from "react";

export default function SalaryWidget() {



    return (
        <div className="salary-widget">
            <div >
                <p>Salaire brut Mars</p>
                <h3>1500€</h3>
            </div>
            <div >
                <p>Salaire brut Avril</p>
                <h3>1500€</h3>
            </div>
            <div >
                <p>Prochaine paie dans 12 jours, le 10 juillet</p>
                <div>
                    <span></span>
                </div>
            </div>
        </div>

    );
}